import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { withSystem, withoutSystem } from '../../data/content';
export function TransformationSection() {
  return <section id="transformation" className="bg-brand-night px-5 py-14 text-white sm:py-20" data-id="element-121" data-mp="3l5liseq8xk3u">
      <div className="mx-auto max-w-5xl" data-id="element-122" data-mp="3q4pogvdyozpf">
        <SectionHeading tone="dark" title="Imagine Your Next Client Booking..." data-id="element-123" data-mp="3q3mx6mcq8v8z" />

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-124" data-mp="3b6xdmgjd0zhk">
          <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 sm:p-7" data-id="element-125" data-mp="3g837wiso4ut7">
            <h3 className="text-sm font-black uppercase tracking-[0.16em] text-white/55" data-id="element-126" data-mp="328bvunlppohu">Without a system</h3>
            <ul className="mt-5 space-y-3.5" role="list" data-id="element-127" data-mp="3763mzfej96kz">
              {withoutSystem.map(item => <li key={item} className="flex items-start gap-3 text-base text-white/65" data-id="element-128" data-mp="10g5v3smbqbif">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-red-500/15 text-red-400" data-id="element-129" data-mp="15g1vlhvtbkt8">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-130" data-mp="mukpxr6tejzb" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-brand-violet/60 bg-brand-violet/15 p-6 shadow-xl shadow-brand-violet/10 sm:p-7" data-id="element-131" data-mp="wkm3vq5gem0i">
            <h3 className="text-sm font-black uppercase tracking-[0.16em] text-brand-lilac" data-id="element-132" data-mp="rp6pmx3jao3k">With Astrologer Ready</h3>
            <ul className="mt-5 space-y-3.5" role="list" data-id="element-133" data-mp="3w1bykt98h3zd">
              {withSystem.map(item => <li key={item} className="flex items-start gap-3 text-base font-bold text-white" data-id="element-134" data-mp="dv60mv2dwfge">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-cta text-white" data-id="element-135" data-mp="8wmd4q856vlx">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-136" data-mp="1p9jm5t9o0it9" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-3xl font-bold leading-tight sm:text-4xl lg:text-5xl" data-id="element-137" data-mp="1sbfm7rk6ylg0">
          Stop preparing harder.{' '}
          <span className="text-brand-lilac" data-id="element-138" data-mp="21cduwn5krh4x">Start preparing smarter.</span>
        </p>
      </div>
    </section>;
}